import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeeContacts: [],
    employeeContactsCount: 0,
    employeeContact: {},
    employeeContactSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeeContacts(state) {
      return state.employeeContacts
    },
    getEmployeeContactsCount(state) {
      return state.employeeContactsCount
    },
    getEmployeeContact(state) {
      return state.employeeContact
    },
    getEmployeeContactSaveStatus(state) {
      return state.employeeContactSave
    },
  },
  mutations: {
    EMPLOYEE_CONTACTS_LIST(state, data) {
      state.employeeContacts = data
    },
    EMPLOYEE_CONTACT_VIEW(state, data) {
      state.employeeContact = data
    },
    EMPLOYEE_CONTACTS_COUNT(state, data) {
      state.employeeContactsCount = data
    },
    EMPLOYEE_CONTACT_SAVE(state, data) {
      state.employeeContactSave = data
    },
  },
  actions: {
    employeeContactsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_contact', data)
        .then(response => {
          commit('EMPLOYEE_CONTACTS_LIST', response.data.data)
          commit('EMPLOYEE_CONTACTS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeeContactView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_contact.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_contact', data)
        .then(response => {
          commit('EMPLOYEE_CONTACT_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeeContactSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_contact/saveData', data)
        .then(response => {
          commit('EMPLOYEE_CONTACT_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
